import {environmentTypeEnumerate, getServerEnvironment} from '@aofl/server-environment';
import {SearchParams} from '@modules/search-url-params';

const DEV_ENV_REGEX = /localhost|sbx|dev|sbx-sharedservices/;
const STAGE_ENV_REGEX = /stage|stg|stg-sharedservices/;
const serverEnvironment = getServerEnvironment(DEV_ENV_REGEX, STAGE_ENV_REGEX);
const DEV = serverEnvironment === environmentTypeEnumerate.DEV;
const STAGE = serverEnvironment === environmentTypeEnumerate.STAGE;
const PROD = !DEV && !STAGE;

const defaultLocale = 'en-US';

const supportedLocales = [
  'en-US',
  'ja-JP',
  'zh-CN',
  'zh-TW',
  'es-US',
];

const thirdPartyRosterSystemsMap = {
  'clever': 'Clever',
  'classlink': 'ClassLink',
  'sftp': 'SFTP',
  'schoology': 'Schoology',
};

const thirdPartyRosterSystems = {
  clever: 'clever',
  classlink: 'classLink',
  sftp: 'sftp',
  schoology: 'schoology',
  aofl_rostering_solution: 'ars',
};

const supportedLocalesMap = {
  'en': 'en-US',
  'ja': 'ja-JP',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  'es-US': 'es-US',
};
const onTrackStatusMap = {
  'hit_target': 'hit_target',
  'not_on_track': 'not_on_track',
  'on_track': 'on_track',
};

const environment = {
  PUBLIC_PATH: __webpack_public_path__, // eslint-disable-line camelcase
  DEV_ENV_REGEX,
  STAGE_ENV_REGEX,
  SERVER: serverEnvironment,
  DEV,
  STAGE,
  PROD,
  DEV_BUILD: process.env.NODE_ENV === environmentTypeEnumerate.DEV,
  PROD_BUILD: process.env.NODE_ENV === environmentTypeEnumerate.PROD,
};

const localStorageKeys = {
  LANG: '75725',
  SHOW_CAREGIVER_FIELDS: '75726',
  SAGE_PROGRESS_DATA_V2: 'SAGE_PROGRESS_DATA_V2',
};

const cacheNamespaces = {
  AUTH_API: 'auth-api',
  MANUAL_ROSTER_API: 'manual-roster-api',
  LICENSE_API: 'license-api',
  USER_API: 'user-api',
  DASHBOARD_STATS_API: 'dashboard-stats-api',
  HELP_RESOURCE: 'help-resource',
};

const apiFormatters = {
  BASIC: 'basic-api-formatter',
  UPLOAD: 'file-upload-api-formatter',
  DOWNLOAD: 'file-download-api-formatter',
};
const apiNamespaces = {
  EMS: 'ems',
};

const sdoNs = {
  ADMIN_UINFO: 'admin-user-info',
  AVERAGE_USAGE_REPORT_TABS: 'average-usage-report-tabs',
  COLLAPSE: 'collapse',
  DROPDOWN: 'dropdowns',
  TEACHER_DASHBOARD: 'teacher-dashboard',
  ABC_TEACHER_DASHBOARD: 'abc-teacher-dashboard',
  MM_TEACHER_DASHBOARD: 'mm-teacher-dashboard',
  ABC_ENGLISH_TEACHER_DASHBOARD: 'abcmouse-english-teacher-dashboard',
  MM_DASHBOARD: 'mm-dashboard',
  ABC_ENGLISH_DASHBOARD: 'abcmouse-english-dashboard',
  ABC_DASHBOARD: 'abc-dashboard',
  RIQ_DASHBOARD: 'riq-dashboard',
  CONCEPTS_MASTERED: 'concepts-mastered',
  OVERALL_PROGRESS: 'teacherOverallProgress',
  LOCALE_DD: 'locale-dd',
  T_OVERVIEW: 'teacherOverview',
  PRINTABLE_RESOURCES: 'printable-resources',
  ABC_ENGLISH_STUDENT_PROGRESS_VIEW: 'abc-english-student-progress-view',
  ABC_STUDENT_PROGRESS_VIEW: 'abc-student-progress-view',
  MM_STUDENT_PROGRESS_VIEW: 'mm-student-progress-view',
  MASTERY_SHARED_STUDENT_PROGRESS: 'mastery-shared-student-progress',
  MRA_STUDENT_PROGRESS_VIEW: 'mra-student-progress-view',
  STUDENT_ENGAGEMENT_TRACKER: 'student-engagement-tracker',
  TIME_SPENT_VIEW: 'time-spent-view',
  TIME_SPENT_HOME_AND_SCHOOL_VIEW: 'time-spent-home-and-school-view',
  PROGRESS_FILTERS_VIEW: 'progress-filters-view',
  GROUP_SEARCH: 'group-search',
  LAYOUT: 'layout',
  LEFT_MENU: 'left-menu',
  ORG_GROUP_INFO: 'org-group-info',
  SKILLS: 'skills',
  CLASSROOM_GROUP_INFO: 'classroom-group-info',
  USER_JOBS: 'user-jobs',
  DASHBOARD: 'dashboard',
  GROUP_FILTERS: 'group-filters',
  GROUP_FILTERS_MENU: 'group-filters-menu',
  TABS: 'ems-tabs',
  SITE_HEADER: 'site-header',
  SESSION: 'session',
  SIDE_PANELS: 'sidePanels',
  STUDENT_INFO: 'studentInfo',
  TEACHER_INFO: 'teacherInfo',
  USER_SEARCH: 'user-search',
  GROUP_SUMMARIES: 'group-summaries',
  LICENSES: 'licenses',
  LICENSE_ASSIGN: 'license-assign',
  LICENSE_ASSIGNMENT_LOG: 'license-assignment-log',
  LICENSE_DISTRIBUTE: 'license-distribute',
  LICENSE_INVENTORY_ALLOCATION: 'license-inventory-allocation',
  LICENSE_HISTORY: 'license-history',
  PARENT_INFO: 'parent-info',
  INVENTORY_UPDATE_LOG: 'inventory-update-log',
  SIMPLE_MODAL: 'ems-simple-modals',
  SAVED_SEARCHES: 'saved-searches',
  RESOURCES: 'resources',
  GROUP_CONCEPTS_MASTERED: 'group-concepts-mastered',
  SUPPORT_WIDGET: 'support-widget',
  ACADEMY_GROUP_DASHBOARD: 'academy-group-dashboard',
  ACADEMY_TEACHER_DASHBOARD: 'academy-teacher-dashboard',
  STUDENT_STATUS_LIST: 'student-status-list',
  ACADEMY_LESSON_DETAILS: 'academy-lesson-details',
  MAP_STUDENT_DASHBOARD: 'map-student-dashboard',
  STUDENT_DASHBOARD: 'student-dashboard',
  PARENT_DASHBOARD: 'parent-dashboard',
  PARENT_STUDENT_DASHBOARD: 'parent-student-dashboard',
  ACADEMY_SHARED_STUDENT_PROGRESS: 'academy-shared-student-progress',
  ACADEMY_TEACHER_OVERALL_PROGRESS: 'academy-teacher-overall-progress',
  LAST_UPDATED: 'last-updated',
  PRINT_REPORTS: 'print-reports',
  USAGE_TRACKER_HISTORIC: 'usage-tracker-historic',
  STUDENT_TIME_SPENT_BY_WEEK: 'student-time-spent-by-week',
  GROUP_HISTORIC_USAGE: 'group-historic-usage',
  USAGE_TRACKER_WEEKLY_ACTIVITY: 'usage-tracker-weekly-activity',
  DASHBOARD_PROGRESS: 'dashboard-progress',
};

const chartTypes = {
  USAGE: 'usage',
  MASTERY_ACTIVITY: 'activityStatus',
  PROGRESS: 'progress',
  ACTIVITY: 'activity',
};

const usageBlocks = {
  MINUTES_1: 'minutes1',
  MINUTES_16: 'minutes16',
  MINUTES_21: 'minutes21',
  MINUTES_31: 'minutes31',
  MINUTES_41: 'minutes41',
  MINUTES_45: 'minutes45',
  MINUTES_60: 'minutes60',
};

const targetBlocks = {
  LOW: 'low',
  MED: 'med',
  HIGH: 'high',
};

const masteryActivityBlocks = {
  STRUGGLING: 'struggling',
  IN_PROGRESS: 'in_progress',
  INACTIVE: 'inactive',
};

const exceptionCodes = {
  AUTHENTICATION_GENERAL: 114000,
  AUTHENTICATION_INVALID_TOKEN: 114001,
  AUTHENTICATION_EXPIRED_TOKEN: 114002,
  AUTHENTICATION_FREQUENT_ATTEMPTS: 114003,

  INPUT_GENERAL: 114100,
  INPUT_NO_RECORDS_FOUND: 114101,
  INPUT_DUPLICATE: 114102,
  INPUT_CONFLICTING_PRODUCT_CREDENTIALS: 114103,
  INPUT_INVALID_ENCODING: 114104,
  INPUT_DUPLICATE_EMAIL: 114105,
  INPUT_DUPLICATE_PHONE: 114106,
  INPUT_INVALID_MAX_EXTERNAL_ID: 114107,
  INPUT_INVALID_REDEEM_CODE: 114108,
  INPUT_USER_TYPE_CONFLICT_EMAIL: 114109,
  INPUT_USER_TYPE_CONFLICT_PHONE: 114110,
  INPUT_USER_TYPE_CONFLICT_EXTERNAL_ID: 114111,
  INPUT_INVALID_PASSWORD: 114113,
  INPUT_ROSTER_UPLOAD_PERMISSION_REQUIRED: 114115,

  AUTHORIZATION_GENERAL: 114300,
  AUTHORIZATION_NO_ROLE_ASSIGNED: 114301,
  AUTHORIZATION_THIRD_PARTY_ROSTERING_CONNECTED: 114302,

  LOGIC_GENERAL: 114400,
  LOGIC_LICENSE_INVENTORY_INSUFFICIENT: 114401,
  LOGIC_LICENSE_NON_REFUNDABLE: 114402,
  LOGIC_LICENSE_ACTION_RETRY_LIMIT_EXCEEDED: 114403,
  LOGIC_DUPLICATE: 114404,
  LOGIC_RATE_LIMIT: 114405,
  LOGIC_INVALID_TIER_STRUCTURE: 114406,
  LOGIC_CONFLICT: 114407,
  // NOTE: these two share a code in EnterpriseServiceLayer's LogicException; they cannot be told apart by code.
  LOGIC_JSON_SCHEMA_INVALID: 114408,
  LOGIC_AMBIGUOUS: 114408,

  INTERNAL_SERVER_GENERAL: 114500,

  MAINTENANCE: 114600,
  LOCKED: 114601,
};

const nodeStatuses = {
  PRIOR_KNOWLEDGE: 'prior_knowledge',
  CREDITED: 'credited',
  MASTERY_ACHIEVED: 'mastery_achieved',
  IN_PROGRESS: 'in_progress',
  INTERVENTION: 'intervention',
  NOT_STARTED: 'not_started',
};

const abcSubjectBuckets = {
  MATH: 'math',
  ARTS_AND_SCIENCES: 'arts_and_sciences',
  FREE_PLAY: 'free_play',
  READING: 'reading',
};

// Time is based off seconds
const weeklyMinuteTargetGoals = {
  ABCMOUSE: 2700, // 45 minutes
  MATH_ACADEMY: 2700, // 45 minutes
  READING_MASTERY: 3600, // 60 minutes
  MY_READING_ACADEMY: 3600, // 60 minutes
  ABCMOUSE_ENGLISH: 3600, // 60 minutes
};

const abcSubjectBucketColors = {
  [abcSubjectBuckets.MATH]: '#238bfd',
  [abcSubjectBuckets.ARTS_AND_SCIENCES]: '#ff7900',
  [abcSubjectBuckets.FREE_PLAY]: '#ffcf03',
  [abcSubjectBuckets.READING]: '#6cc60a',
};

const modals = {
  CSV_COL_ERROR: 'csv-column-error',
  DID_YOU_KNOW: 'did-you-know',
  ADMIN_CHANGE_PASSWORD: 'admin-change-password',
  CSV_ROW_ERROR: 'csv-row-error',
  SAVE_GROUP_SEARCH_RESULTS: 'saveGroupSearchResults',
  SAVE_USER_SEARCH_RESULTS: 'saveUserSearchResults',
  STUDENT_PROGRESS: 'student-progress',
  INVITATION: 'bulk-invitation',
  ACADEMY_LESSON_DETAILS_MODAL: 'academy-lesson-details-modal',
  PICTURE_PASSCODE_RESET: 'picture-passcode-reset',
  LICENSE_ASSIGN_BULK: 'license-assign-bulk',
  LICENSE_REVOKE_BULK: 'license-revoke-bulk',
  LICENSE_DISTRIBUTE: 'license-distribute',
  LICENSE_EXPLAIN: 'license-explain',
  LICENSE_REVOKE: 'license-revoke',
  LICENSE_TAKE: 'license-take',
  STUDENT_DELETE: 'student-delete',
  STUDENT_DETAILS: 'student-details',
  ARCHIVED_STUDENT: 'archived-student',
  ARCHIVED_TEACHER: 'archived-teacher',
  ABCMOUSE_PASSCODE: 'abcmouse-passcode',
  ABCMOUSE_PASSCODE_RESET: 'abcmouse-passcode-reset',
  PRODUCT_ACTIVATION: 'product-activation',
  CONFIRM_TEACHER_LOGIN_CHANGE: 'confirm-login-change',
  DISCONNECT: 'disconnect',
  CONNECT_TP_ROSTER: 'connect-tp-roster',
  CLASSLINK_APP_VISIBILITY: 'classlink-app-visibility',
  RESOURCE_INFO: 'resource_info',
  RESOURCE_PRINT_REPORT: 'resource_print_report',
  TEACHER_DETAIL: 'teacher-edit',
  ORG_GROUP_DETAILS: 'org-group-details',
  ARCHIVED_GROUP: 'archived-group',
  CLASS_EDIT: 'class-edit',
  ARCHIVED_CLASS: 'archived-class',
  ADMIN_DETAIL: 'admin-detail',
  SYNC_ACCOUNT: 'sync-account',
  SELECT_CHILD: 'select-child',
  CONFIRM_PARENT_ACCOUNT: 'confirm-account',
  LAUNCH_PRODUCT_APP: 'launch-product-app',
  PARENT_REDEEM_CODE: 'redeem-code',
  UPDATE_LOGIN_EMAIL: 'update-login-email',
  UPDATE_LOGIN_PHONE: 'update-login-phone',
  LICENSE_CONFLICT_MODAL: 'license-conflict-modal',
  NO_MORE_LICENSE_AVAILABLE: 'no-more-license-available-modal',
  ROSTER_ERRORS_MODAL: 'roster-errors-modal',
  PARENT_LESSON_DETAILS: 'parent-lesson-details',
  PARENT_FIRST_TIME_USER_EXPERIENCE: 'parent-first-time-user-experience-modal',
  MFA_SELECT: 'mfa-select',
  MFA_ENTER: 'mfa-enter',
  MFA_SETUP: 'mfa-setup',
  STUDENT_RECOMMENDED_ACTIVITY_DETAILS: 'student-recommended-activity-details',
  DASHBOARD_GROUP_MODAL: 'dashboard-group-modal',
  CANCEL_ROSTER_JOB_CONFIRMATION_MODAL: 'cancel-roster-job-confirmation-modal',
  SINGLE_SKILL_CARD_MODAL: 'single-skill-card-modal',
  GENERATE_QR: 'generate-qr',
  CAREGIVER_INVITE: 'caregiver-invite',
};

/** @todo refactor dynamic paths */
const pages = {
  BASE: environment.PUBLIC_PATH,
  HOME: environment.PUBLIC_PATH,
  TOKEN_LOGIN: environment.PUBLIC_PATH + 'login/',
  LOGOUT: environment.PUBLIC_PATH + 'logout/',
  PASSWORD_REQUEST: environment.PUBLIC_PATH + 'password/request',
  PASSWORD_RESET: environment.PUBLIC_PATH + 'password/reset',
  DASHBOARD: environment.PUBLIC_PATH + 'dashboard/',
  LANDING: environment.PUBLIC_PATH + 'landing/',
  ORG_GROUP: environment.PUBLIC_PATH + 'org-group/',
  ADMIN_SEARCH: environment.PUBLIC_PATH + 'admins/',
  ADMIN_PROFILE: environment.PUBLIC_PATH + 'admins/profile/',
  PARENT_REDEEM: environment.PUBLIC_PATH + 'parent/redeem/',
  PARENT_REDEEM_CODE: environment.PUBLIC_PATH + 'parent/redeem-code/',
  PARENT_WELCOME: environment.PUBLIC_PATH + 'parent/welcome/',
  PARENT_DASHBOARD: environment.PUBLIC_PATH + 'parent/dashboard/',
  MY_PROFILE: environment.PUBLIC_PATH + 'profile/',
  ROSTERS: environment.PUBLIC_PATH + 'rosters/',
  ROSTERS_ARCHIVE: environment.PUBLIC_PATH + 'rosters/archive/',
  ROSTERS_UPLOAD_FULL: environment.PUBLIC_PATH + 'rosters/upload/full/',
  ROSTERS_UPLOAD_NEW: environment.PUBLIC_PATH + 'rosters/upload/new/',
  ROSTERS_UPLOAD_ONEROSTER: environment.PUBLIC_PATH + 'rosters/upload/oneroster/',
  ROSTERS_VALIDATE: environment.PUBLIC_PATH + 'rosters/validate/',
  ROSTERS_LICENSE: environment.PUBLIC_PATH + 'rosters/license/',
  STUDENT_SEARCH: environment.PUBLIC_PATH + 'students/',
  STUDENT_SEARCH_ACTIVE: environment.PUBLIC_PATH + 'students/active/',
  STUDENT_CREATE: environment.PUBLIC_PATH + 'students/create/',
  STUDENT_PROFILE: environment.PUBLIC_PATH + 'students/profile/',
  CLASSES_SEARCH: environment.PUBLIC_PATH + 'classes/',
  CLASSES_SEARCH_ACTIVE: environment.PUBLIC_PATH + 'classes/active/',
  CLASSES_CREATE: environment.PUBLIC_PATH + 'classes/create/',
  CLASSES_PROFILE: environment.PUBLIC_PATH + 'classes/edit/',
  TEACHER_SEARCH: environment.PUBLIC_PATH + 'teachers/',
  TEACHER_SEARCH_ACTIVE: environment.PUBLIC_PATH + 'teachers/active/',
  TEACHER_CREATE: environment.PUBLIC_PATH + 'teachers/create/',
  TEACHER_PROFILE: environment.PUBLIC_PATH + 'teachers/profile/',
  RESOURCES: environment.PUBLIC_PATH + 'resources/',
  LICENSES: environment.PUBLIC_PATH + 'licenses/',
  LICENSE_DETAILS: environment.PUBLIC_PATH + 'licenses/details/',
  SAVED_SEARCHES: environment.PUBLIC_PATH + 'reports/',
  ERROR_500: environment.PUBLIC_PATH + '500/',
  ERROR_503: environment.PUBLIC_PATH + '503/',
  LICENSE_HISTORY: environment.PUBLIC_PATH + 'licenses/history/',
  PARENT_HOMEPAGE: environment.PUBLIC_PATH + 'parent/',
  PARENT_PROFILE: environment.PUBLIC_PATH + 'parent/profile',
  PARENT_PROFILE_EDIT: environment.PUBLIC_PATH + 'parent/profile/edit',
  DASHBOARD_PROGRESS: environment.PUBLIC_PATH + 'dashboard/progress/',
  SESSION_MONITOR: environment.PUBLIC_PATH + 'session-monitor/',
  OAUTH: environment.PUBLIC_PATH + 'oauth/',
  UNSUBSCRIBE: environment.PUBLIC_PATH + 'unsubscribe/',
  GETTING_STARTED: environment.PUBLIC_PATH + 'getting-started/',
  ACCOUNT_MANAGEMENT: environment.PUBLIC_PATH + 'account-management/',
  ASSIGN_SKILLS: environment.PUBLIC_PATH + 'assign-skills/',
};

const getDynamicSearchUrl = (urlPath, path, key) => {
  const pathArr = path.split('.');
  pathArr.pop();
  const searchQuery = {
    filters: {
      [key]: pathArr.slice(1)
    },
  };
  const searchParams = SearchParams.encode(searchQuery);
  return `${urlPath}?${searchParams}`;
};

const getDynamicCreateUrl = (urlPath, path, key, includeOrg = false) => {
  let pathArr = path.split('.');
  pathArr.pop();
  if (!includeOrg) {
    pathArr = pathArr.slice(1);
  }

  const searchQuery = {
    filters: {
      [key]: pathArr
    },
    action: 'create'
  };
  const searchParams = SearchParams.encode(searchQuery);

  return `${urlPath}?${searchParams}`;
};

const dynamicPages = {
  orgGroupCreate: (level, path) => getDynamicCreateUrl(pages.ORG_GROUP + level + '/', path, 'parent_group_id', true),
  orgGroupSearch: (level, path) => getDynamicSearchUrl(pages.ORG_GROUP + level + '/', path, 'parent_group_id'),
  classroomCreate: (path) => getDynamicCreateUrl(pages.CLASSES_SEARCH, path, 'classes_path'),
  classroomSearch: (path) => getDynamicSearchUrl(pages.CLASSES_SEARCH, path, 'classes_path'),
  teacherProfile: (id) => `${pages.TEACHER_PROFILE}${id}/`,
  teacherSearch: (path) => getDynamicSearchUrl(pages.TEACHER_SEARCH_ACTIVE, path, 'group_path'),
  teacherCreate: (path) => getDynamicCreateUrl(pages.TEACHER_SEARCH_ACTIVE, path, 'group_path'),
  studentProfile: (id) => `${pages.STUDENT_PROFILE}${id}/`,
  studentSearch: (path) => getDynamicSearchUrl(pages.STUDENT_SEARCH, path, 'group_path'),
  studentCreate: (path) => getDynamicCreateUrl(pages.STUDENT_SEARCH, path, 'group_path'),
  resourcesProduct: (product) => `${pages.RESOURCES}${product}/`,
  licenseDetails: (id) => `${pages.LICENSE_DETAILS}${id}/`,
  parentStudentDashboard: (product, studentId, type) => `${pages.PARENT_DASHBOARD}${studentId}/${product}/${type}`,
  parentDashboard: (studentId) => `${pages.PARENT_DASHBOARD}${studentId}`,
};

const jobTypes = {
  ROSTER_FULL: 'roster_full',
  ROSTER_NEW: 'roster_new',
  ROSTER_EXPORT: 'roster_export',
  LICENSING: 'licensing',
  BULK_REVOKE: 'bulk_revoke',
  EXPORT_SEARCH: 'export_search',
  INVITES: 'invite_letter_send',
  INVITES_PRINT: 'invite_letter_print',
  TEACHER_INVITES: 'teacher_invite_letter_send',
  ADMIN_INVITES: 'admin_invite_letter_send',
  DASHBOARD_CSV_EXPORT: 'dashboard_csv_export',
  GENERATE_QR: 'qr_generate',
  PICTURE_PASSCODE_RESET: 'picture_passcode_reset',
};

const rosterFileTypes = {
  AOFL: 'aofl',
  PROCARE: 'procare',
  CLASSLINK: 'clisslink',
};

const jobStatuses = {
  FAILED: 'failed',
  QUEUED: 'queued',
  ACTIVE: 'active',
  DONE: 'done',
  PENDING: 'pending',
  CANCELED: 'canceled',
};

const filterStatuses = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

const rosterJobStages = {
  ROSTER_PROCESSING_VALIDATE: 'roster_processing_validate',
  ROSTER_VALIDATE_DONE: 'roster_validate_done',
  ROSTER_PROCESSING_COMMIT: 'roster_processing_commit',
  ROSTER_VALIDATE_ERRORS: 'roster_validate_errors',
  EXTERNAL_ACTIONS_START: 'external_actions_start',
  EXTERNAL_ACTIONS_START_DONE: 'immediate_external_actions_completed',
  EMPTY: '',
};

const inviteJobStages = {
  INVITE_BEGIN: 'send_invite_start',
  INVITE_COMPLETE: 'send_invite_complete',
  PRINT_INVITE_BEGIN: 'print_invite_start',
  PRINT_INVITE_COMPLETE: 'print_invite_complete',
};

const bulkRevokeStages = {
  REVOKE_ACTIONS_START: 'external_deactivate_actions_start',
  REVOKE_ACTIONS_QUEUED: 'external_deactivate_actions_queued',
};

const exportJobStages = {
  EXPORT_BEGIN: 'export_begin',
  EXPORT_COMPLETE: 'export_complete',
  EMPTY: '',
};

const qrJobStages = {
  GENERATE_QR_BEGIN: 'generate_qr_begin',
  GENERATE_QR_COMPLETE: 'generate_qr_complete',
};

const picturePasscodeResetJobStages = {
  PICTURE_PASSCODE_RESET_BEGIN: 'picture_passcode_reset_begin',
  PICTURE_PASSCODE_RESET_COMPLETE: 'picture_passcode_reset_complete',
};

const autoLicenseErrors = {
  LOW_QUANTITY: 'low_quantity',
};

const rosterErrors = {
  AMBIGUOUS: 'ambiguous',
  CONFLICTING_PRODUCT_EMAIL: 'conflicting_product_email',
  CSV_INVALID_COLUMN_COUNT: 'invalid_column_count',
  CSV_INVALID_PROPERTY: 'invalid_property',
  DUPLICATE_EMAIL: 'duplicate_email',
  DUPLICATE_PHONE: 'duplicate_phone',
  EMAIL_IN_USE_BY_ADMIN: 'email_in_use_by_admin',
  FILE_NOT_FOUND: 'file_not_found',
  ID_MISMATCH: 'id_mismatch',
  ID_REUSE_MISMATCH: 'id_reuse_mismatch',
  INVALID_EMAIL: 'invalid_email',
  INVALID_NAME: 'invalid_name',
  INVALID_COUNTRY_CODE: 'invalid_country_code',
  INVALID_EXTERNAL_ID_LENGTH: 'invalid_external_id_length',
  INVALID_LANGUAGE: 'invalid_language',
  INVALID_MONTH: 'invalid_month',
  INVALID_PHONE: 'invalid_phone',
  INVALID_SWAP_OF_GROUP_LEVEL: 'invalid_swap_of_group_level',
  INVALID_TIERS: 'invalid_tiers',
  INVALID_YEAR: 'invalid_year',
  NO_EMAIL_OR_PHONE: 'no_phone_or_email',
  REPLACEMENT_ID_ARCHIVED: 'replacement_id_archived',
  REPLACEMENT_ID_MISMATCH: 'replacement_id_mismatch',
  REPLACEMENT_ID_USED: 'replacement_id_used',
  REQUIRED: 'required',
  MISSING_HEADER: 'missing_header',
  INVALID_REFERENCE: '2c93346c-f635-43ff-b521-7fe5aaaabda8',
  NOT_EQUAL_ERROR: '478618a7-95ba-473d-9101-cabd45e49115',
  NO_SUCH_CHOICE_ERROR: '8e179f1b-97aa-4560-a02f-2a8b42e49df7',
  MISSING_FIELD_ERROR: '2fa2158c-2a7f-484b-98aa-975522539ff8',
  IS_BLANK_ERROR: 'c1051bb4-d103-4f74-8988-acbcafc7fdc3',
  INVALID_DATE_FORMAT_ERROR: '1a9da513-2640-4f84-9b6a-4d99dcddc628',
  INVALID_DATE_ERROR: '3c184ce5-b31d-4de7-8b76-326da7b2be93',
  INVALID_TIME_ERROR: '8532f9e1-84b2-4d67-8989-0818bc38533b',
  INVALID_PHONE_FORMAT_ERROR: 'c004fb12-7688-4fb7-8b26-a2dcb726b759',
  FILE_NOT_FOUND_ERROR: 'd2a3fb6e-7ddc-4210-8fbf-2ab345ce1998',
  NO_SUCH_FIELD_ERROR: '7703c766-b5d5-4cef-ace7-ae0dd82304e9',
  ID_MISMATCH_NEW: '3e86c023-aafa-4ca6-b6e5-28f690a05ab8',
  UNKNOWN_HEADER: '1242911e-36e6-4d67-a67c-5bc8cfa8c2d0',
  INVALID_USER_ROLE_REFERENCE: 'fbc9f08f-3ea1-434e-ba8c-0d98d44011df',
  INCOMPLETE_DELETION: 'b5e76c85-9eee-4de9-83f4-597b6cc039ca',
  INVALID_CLASS_PARENT: 'eec6ef2d-a773-4828-ace7-ef544011847e',
  INVALID_ORG_STATUS: '10011f0d-d91f-4fc8-aa04-9cce0ae93f42',
  INVALID_ORG_STRUCTURE: 'cb9d8f51-965b-4cf7-83d2-a19d4dafb0bd',
  INVALID_MANAGED_RECORD_STATUS: 'invalid_managed_record_status',
};

const rosterJobStatusPagesMap = {
  [jobStatuses.FAILED]: pages.ROSTERS_ARCHIVE,
  [jobStatuses.QUEUED]: pages.ROSTERS_VALIDATE,
  [jobStatuses.ACTIVE]: pages.ROSTERS_VALIDATE,
  [jobStatuses.PENDING]: pages.ROSTERS_VALIDATE,
  [jobStatuses.DONE]: pages.ROSTERS_ARCHIVE,
  [jobStatuses.CANCELED]: pages.ROSTERS_ARCHIVE,
};

const products = {
  ABCMOUSE: 'abcmouse',
  READINGIQ: 'readingiq',
  MATH_ACADEMY: 'mathmastery', // this will eventually will be deprecated for MY_MATH_ACADEMY
  READING_MASTERY: 'readingmastery', // this will eventually be deprecated for MY_READING_ACADEMY
  ADVENTURE_ACADEMY: 'academy',
  ABCMOUSE_ENGLISH: 'abcmouse_english',
  MY_MATH_ACADEMY: 'my_math_academy',
  MY_READING_ACADEMY: 'my_reading_academy',
  MY_READING_ACADEMY_ES: 'my_reading_academy_es',
};

const statsProducts = {
  ALL: 'all',
  ...products,
};

const colorMap = {
  minutes45: '#641da3',
  minutes31: '#956abc',
  minutes16: '#c7afdd',
  minutes1: '#e0d2ed',
  active: '#33B0F6',
  mastery_achieved: '#07A133',
  completed: '#2ca22c',
  prior_knowledge: '#edf887',
  credited: '#89FF6C',
  not_started: '#D8D8D8',
  on_track: '#ADE0BE',
  targetHigh: '#55B505',
  targetMed: '#FFCF00',
  targetMedOrange: '#F6993B',
  targetLow: '#FE3E55',
  darkBlue: '#0036A3',
  midBlue: '#1280F5',
  darkYellow: '#F5C323',
  grey: '#B5B5B5',
  in_progress: '#1280F5',
  intervention: '#f6993b',
  struggling: '#f6993b',
  inactive: '#d8d8d8',
  black: '#000000',
  white: '#FFFFFF',
  notActive: '#E50B0A',
  rangeLow: '#FFD29C',
  rangeMed: '#82C6F4',
  rangeHigh: '#C1EFAB',
  mon: '#F1E1FF',
  tue: '#E4CEF9',
  wed: '#D4B0F5',
  thu: '#C08FEC',
  fri: '#A96FDD',
  sat: '#D8D8D8',
  sun: '#D8D8D8',
};

const productLabels = {
  [products.ABCMOUSE]: 'ABCmouse',
  [products.READINGIQ]: 'Reading IQ',
  [products.MATH_ACADEMY]: 'My Math Academy',
  [products.READING_MASTERY]: 'My Reading Academy',
  [products.ABCMOUSE_ENGLISH]: 'ABCmouse Aprende Inglés',
  [products.MY_MATH_ACADEMY]: 'My Math Academy',
  [products.MY_READING_ACADEMY]: 'My Reading Academy',
  [products.MY_READING_ACADEMY_ES]: 'My Reading Academy Español',
};

const teacherAccessStatuses = {
  NOT_INVITED: 'not_invited',
  INVITED: 'invited',
  ACTIVATED: 'activated',
  INVALID_EMAIL: 'invalid_email',
};

// Unassigned -> Assigned/Not Activated/Not Redeemed -> Invited -> Redeemed/Activated -> Expired
const productStatuses = {
  UNASSIGNED: 'unassigned',
  ASSIGNED: 'assigned',
  NOT_ACTIVATED: 'not_activated',
  INVITE_SENT: 'invite_sent',
  NOT_REDEEMED: 'not_redeemed', // Label for Teachers for 'Assigned'
  REDEEMED: 'redeemed',
  ACTIVATED: 'activated',
  EXPIRED: 'expired',
  INVALID_EMAIL: 'invalid_email',
  ASSIGNED_INVITED_REDEEMED: 'assigned_invited_redeemed', // combo status for assigned, invited, redeemed
  NOT_ACTIVATED_AND_ACTIVATED: 'not_activated_and_activated', // label for Teachers for ASSIGNED_INVITED_REDEEMED
  NOT_REDEEMED_AND_REDEEMED: 'not_redeemed_and_redeemed', // label for Teachers for ASSIGNED_INVITED_REDEEMED
  EXPIRING_SOON: 'expiring_soon',
};
const status = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
};

const selectionModes = {
  SELECT_ALL: 'all',
  SELECT_PAGE: 'page',
};
const licenseAssignMode = {
  FILTERED: 'filtered',
  SELECTED: 'selected',
};

const objectTypes = {
  STUDENT: 'student',
  GROUP: 'group',
  USER: 'user',
};

const dashboardGroupTypes = {
  STUDENT: 'student',
  GROUP: 'group',
};

const licenseTypes = {
  site: 'Site',
  seat: 'Seat',
  inventory: 'Inventory',
};

const licenseTransferTypes = {
  transferTo: 'transfer_to',
  transferFrom: 'transfer_from',
};

const licenseHomeAccessTypes = {
  FULL: 'full',
  LIMITED: 'limited',
  NONE: 'none',
};

const activationStartType = {
  ON_LICENSE: 'on_license',
  ON_REDEEM: 'on_redeem',
};

const licenseDurationLabels = {
  P1M: '1 Month',
  P6M: '6 Months',
};

const permissions = {
  ALL: 'all',
  READ: 'read',
  SPONSOR: 'sponsor',
  HIDE_STUDENT: 'hide_student',
  USER_EDIT: 'user.update',
  TEACHER_EDIT: 'teacher.update',
  STUDENT_EDIT: 'student.update',
  GROUP_EDIT: 'group.update',
  PASSWORD_RESET: 'password.reset',
  ROSTER: 'roster', /** @todo what is this? */
  ROSTER_FULL: 'roster.full',
  LICENSE_TRANSFER: 'license.transfer',
  LICENSE_APPLY: 'license.apply',
  EXPORT_ALL: 'roster.export_all',
  SFTP: 'sftp.manage',
};

const permissionGroupKeys = {
  ADMIN_ACCOUNTS: 'ADMIN_ACCOUNTS',
  MANUAL_ROSTER: 'MANUAL_ROSTER',
  ROSTER_UPLOAD: 'ROSTER_UPLOAD',
  LICENSE: 'LICENSE',
  SFTP: 'SFTP',
  READ: 'READ',
};

const permissionGroups = {
  [permissionGroupKeys.ADMIN_ACCOUNTS]: [permissions.USER_EDIT],
  [permissionGroupKeys.MANUAL_ROSTER]: [
    permissions.TEACHER_EDIT,
    permissions.STUDENT_EDIT,
    permissions.GROUP_EDIT,
    permissions.EXPORT_ALL,
  ],
  [permissionGroupKeys.ROSTER_UPLOAD]: [
    permissions.ROSTER,
    permissions.ROSTER_FULL,
  ],
  [permissionGroupKeys.LICENSE]: [
    permissions.LICENSE_APPLY,
    permissions.LICENSE_TRANSFER,
  ],
  [permissionGroupKeys.SFTP]: [permissions.SFTP],
  [permissionGroupKeys.READ]: [permissions.READ],
};

const permissionsReverseMap = {
  [permissions.ALL]: [
    permissionGroupKeys.ADMIN_ACCOUNTS,
    permissionGroupKeys.MANUAL_ROSTER,
    permissionGroupKeys.ROSTER_UPLOAD,
    permissionGroupKeys.LICENSE,
  ],
  [permissions.USER_EDIT]: [permissionGroupKeys.ADMIN_ACCOUNTS],
  [permissions.TEACHER_EDIT]: [permissionGroupKeys.MANUAL_ROSTER],
  [permissions.STUDENT_EDIT]: [permissionGroupKeys.MANUAL_ROSTER],
  [permissions.GROUP_EDIT]: [permissionGroupKeys.MANUAL_ROSTER],
  [permissions.PASSWORD_RESET]: [permissionGroupKeys.MANUAL_ROSTER],
  [permissions.ROSTER]: [permissionGroupKeys.ROSTER_UPLOAD],
  [permissions.ROSTER_FULL]: [permissionGroupKeys.ROSTER_UPLOAD],
  [permissions.LICENSE_TRANSFER]: [permissionGroupKeys.LICENSE],
  [permissions.LICENSE_APPLY]: [permissionGroupKeys.LICENSE],
  [permissions.SFTP]: [permissionGroupKeys.SFTP],
  [permissions.EXPORT_ALL]: [permissionGroupKeys.MANUAL_ROSTER],
};

const levelRestrictedPermissions = {
  '1': [permissions.ROSTER_FULL],
};

const levelExcludedPermissions = {
  '-1': [permissions.LICENSE_TRANSFER],
  '-2': [permissions.LICENSE_TRANSFER],
};

const licenseActions = {
  LICENSE_ASSIGNED: 'license_assigned',
  LICENSE_REVOKED: 'license_revoked',
  LICENSE_TRANSFERRED: 'license_transferred',
  LICENSE_CREATED: 'license_created',
  LICENSE_DEACTIVATED: 'license_deactivated',
  LICENSE_EXTENDED: 'license_extended',
  LICENSE_EXPIRED: 'license_expired',
  LICENSE_TAKEN: 'license_taken',
  LICENSE_GIVEN: 'license_given',
};

const grades = {
  NOT_SET: 'Not Set',
  TODDLERTIME: 'toddlertime',
  PRESCHOOL: 'preschool',
  PREKINDERGARTEN: 'prekindergarten',
  TRANSITIONAL_KINDERGARTEN: 'transitionalkindergarten',
  THREE_YEAR_OLDS: '3-year-olds',
  FOUR_YEAR_OLDS: '4-year-olds',
  FIVE_YEAR_OLDS: '5-year-olds',
  PRE_K: 'Pre-K',
  KINDERGARTEN: 'kindergarten',
  GRADE_1: '1',
  GRADE_2: '2',
  GRADE_3: '3',
  GRADE_4: '4',
  GRADE_5: '5',
  GRADE_6: '6',
  GRADE_7: '7',
  GRADE_8: '8',
  GRADE_9: '9',
  GRADE_10: '10',
  GRADE_11: '11',
  GRADE_12: '12',
  OTHER: 'other',
};

const curriculumSearchGrades = {
  PRE_K: 'Pre-K',
  KINDERGARTEN: 'Kindergarten',
  GRADE_1: '1st Grade',
  GRADE_2: '2nd Grade',
};

const conflictStatus = {
  NO_CONFLICT: 'no_conflict',
  CANNOT_REDEEM: 'cannot_redeem',
};

const studentDetailSections = {
  INFO: 'info',
  DASHBOARD: 'dashboard',
  LICENSES: 'licenses',
  UNSAVED_CHANGES: 'unsaved-changes',
  ARCHIVE_NOTIFICATION: 'archive-notification',
  TRANSFER_LICENSES: 'transfer-licenses',
};

const lessonDetailSections = {
  RECOMMENDED_ACTIVITY: 'recommended-activity',
  PDF: 'pdf',
  LESSON: 'lesson',
};

const userTypes = {
  ADMIN: 'admin',
  TEACHER: 'teacher',
  PARENT: 'parent',
};

const aggregate = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  ALLTIME: 'alltime',
};

const groupTypes = {
  CLASSROOM: 'classroom',
  MANAGEMENT: 'management',
};

const productLogos = {
  [products.MATH_ACADEMY]: {
    icon: {
      active: require('@assets/images/mathmastery/my-math-academy.webp'),
      width: 176,
      height: 20,
    },
  },
  [products.MY_MATH_ACADEMY]: {
    icon: {
      active: require('@assets/images/my_math_academy/my-math-academy.webp'),
      width: 176,
      height: 20,
    }
  },
  [products.READING_MASTERY]: {
    icon: {
      active: require('@assets/images/readingmastery/mra-color.webp'),
      width: 204,
      height: 20,
    },
  },
  [products.MY_READING_ACADEMY]: {
    icon: {
      active: require('@assets/images/my_reading_academy/mra-color.webp'),
      width: 204,
      height: 20,
    },
  },
  [products.MY_READING_ACADEMY_ES]: {
    icon: {
      active: require('@assets/images/my_reading_academy_es/mrae-color.webp'),
      width: 200,
      height: 34,
    },
  },
  [products.ABCMOUSE]: {
    icon: {
      active: require('@assets/images/abcmouse/abcmouse.svg'),
      width: 106,
      height: 18,
    },
  },
  [products.ABCMOUSE_ENGLISH]: {
    icon: {
      active: require('@assets/images/abcmouse_english/abc_english_single_line.webp'),
      width: 214,
      height: 18,
    },
  },
  [products.READINGIQ]: {
    icon: {
      active: require('@assets/images/readingiq/readingiq.svg'),
      width: 112,
      height: 23,
    },
  },
};

const recommendedActivityType = {
  ONE_ON_ONE: 'one_on_one',
  GROUP: 'group',
};

const docebo = {
  DOCEBO_CLIENT_ID: 'docebo',
};

const ssoErrors = {
  DOCEBO_DISABLED: 'docebo_disabled',
  PROFESSIONAL_LEARNING_DISABLED: 'professional_learning_disabled',
  GENERIC: 'generic',
};

const resourceModalCategories = {
  LESSONS: 'lessons',
};

const dateFormats = {
  serverFormat: 'yyyy-MM-dd',
};

const dashboardTabs = {
  PROGRESS: 'progress',
  USAGE: 'usage',
  SNAPSHOT: 'snapshot',
  TRACKER: 'tracker',
  THIS_WEEK: 'thisWeek',
  OVERALL_PROGRESS: 'overall-progress',
  CONCEPTS_MASTERED: 'concepts-mastered',
  BY_MONTH: 'by-month',
  BY_WEEK: 'by-week',
};

const landingPageProducts = [
  products.MY_MATH_ACADEMY,
  products.MY_READING_ACADEMY,
  products.MY_READING_ACADEMY_ES,
];

const creditedProducts = [
  products.MY_MATH_ACADEMY,
  products.MY_READING_ACADEMY,
];

const productOrder = [
  products.MY_MATH_ACADEMY,
  products.MY_READING_ACADEMY,
  products.MY_READING_ACADEMY_ES,
  products.MATH_ACADEMY,
  products.ABCMOUSE,
  products.ABCMOUSE_ENGLISH,
  products.READINGIQ,
];

const productKeepGrayScale = [
  products.ABCMOUSE,
  products.ABCMOUSE_ENGLISH,
  products.READINGIQ,
];

const printReportTypes = {
  PLACEMENT: 'placement',
  SUMMARY: 'summary',
  SKILL_LIST: 'skill_list',
  GROWTH: 'growth',
};

const printReportLabels = {
  [printReportTypes.PLACEMENT]: 'Placement',
  [printReportTypes.SUMMARY]: 'Summary',
  [printReportTypes.SKILL_LIST]: 'Skill List',
  [printReportTypes.GROWTH]: 'Growth',
};

const reportTypes = {
  DISTRICT: 'district',
  SCHOOL: 'school',
  CLASSROOM: 'classroom',
  STUDENT: 'student',
};

const featureFlags = {
  HAS_LO_RECOMMENDER: 'has_lo_recommender',
  ALLOW_LEARNING_ASSISTANT: 'allow_learning_assistant',
};

export {
  colorMap,
  abcSubjectBucketColors,
  abcSubjectBuckets,
  weeklyMinuteTargetGoals,
  masteryActivityBlocks,
  localStorageKeys,
  supportedLocales,
  supportedLocalesMap,
  cacheNamespaces,
  apiFormatters,
  apiNamespaces,
  sdoNs,
  environment,
  pages,
  dynamicPages,
  jobTypes,
  licenseActions,
  rosterFileTypes,
  jobStatuses,
  filterStatuses,
  rosterJobStages,
  inviteJobStages,
  bulkRevokeStages,
  qrJobStages,
  picturePasscodeResetJobStages,
  rosterErrors,
  rosterJobStatusPagesMap,
  products,
  statsProducts,
  exportJobStages,
  productLabels,
  productStatuses,
  selectionModes,
  licenseAssignMode,
  objectTypes,
  dashboardGroupTypes,
  licenseTypes,
  licenseHomeAccessTypes,
  licenseTransferTypes,
  licenseDurationLabels,
  modals,
  permissions,
  permissionGroupKeys,
  permissionGroups,
  permissionsReverseMap,
  levelRestrictedPermissions,
  levelExcludedPermissions,
  exceptionCodes,
  nodeStatuses,
  teacherAccessStatuses,
  chartTypes,
  usageBlocks,
  targetBlocks,
  thirdPartyRosterSystemsMap,
  grades,
  studentDetailSections,
  lessonDetailSections,
  status,
  autoLicenseErrors,
  userTypes,
  aggregate,
  conflictStatus,
  groupTypes,
  activationStartType,
  curriculumSearchGrades,
  productLogos,
  recommendedActivityType,
  docebo,
  ssoErrors,
  resourceModalCategories,
  onTrackStatusMap,
  dateFormats,
  dashboardTabs,
  landingPageProducts,
  creditedProducts,
  productOrder,
  printReportTypes,
  printReportLabels,
  productKeepGrayScale,
  defaultLocale,
  thirdPartyRosterSystems,
  reportTypes,
  featureFlags,
};
